import { ApiBase } from '@/api/methods/ApiBase'
import { ApiResponseStudyReviewLearning } from '@/api/responses/study/studyReviewLearnings'

export namespace StudyReviewLearningsApi {
  /**
   * 復習BOX学習の結果登録
   *
   * @param fixedExerciseId 固定問題ID
   * @param problemId 小問ID
   * @param questionInputs 設問解答情報(設問と解答欄単位の二次元配列)
   * @param startedUnixTime 演習開始時刻(UNIX時刻-秒)
   * @returns 登録結果
   */
  export async function postStudyReviewLearning(
    fixedExerciseId: number,
    problemId: number,
    questionInputs: string[][],
    startedUnixTime: number
  ): Promise<ApiResponseStudyReviewLearning> {
    const params = {
      fixedExerciseId: fixedExerciseId,
      problemId: problemId,
      questionInputs: questionInputs,
      startedTimestamp: startedUnixTime,
    }
    return await ApiBase.post('/study/reviewLearnings', params)
  }
}
